// Add your custom JS here.
var CRUMINA = {};
var $window = jQuery(window),
    $document = jQuery(document),
    $body = jQuery('body'),

    swipers = {},
    //Elements,
    $header = jQuery('#wrapper-navbar'),
    $counter = jQuery('.counter'),
    $animatedIcons = jQuery('.js-animate-icon');



//Slider Set Height depend of Classes.
CRUMINA.resizeSwiper = function (swiper) {
    jQuery('.swiper-container.auto-height').each(function () {
        swiper = (swiper) ? swiper : jQuery(this)[0].swiper;
        var activeSlideHeight = swiper.slides.eq(swiper.activeIndex).height();
        swiper.container.css({height: activeSlideHeight + 'px'});
        swiper.onResize();
    });
};

jQuery(document).ready(function($) {

	// Fixed Header
	$header.headroom(
        {
            "offset": 210,
            "tolerance": 5,
            "classes": {
                "initial": "animated",
                "pinned": "swingInX",
                "unpinned": "swingOutX"
            }
        }
    );
	
	//Scroll to top.
	jQuery('#back_to_top').click(function(event) {
		jQuery('html, body').animate({scrollTop : 0},800);
        return false;
	});

	// Counters
	if ($counter.length) {
        $counter.each(function () {
            jQuery(this).waypoint(function () {
                jQuery(this.element).find('span').countTo();
                this.destroy();
            }, {offset: '95%'});
        });
    }

    // Draw SVG Icons 
    if ($animatedIcons.length) {
        $animatedIcons.each(function () {
            jQuery(this).waypoint(function () {
                var mySVG = jQuery(this.element).find('> svg').drawsvg();
                mySVG.drawsvg('animate');
                this.destroy();
            }, {offset: '95%'});
        });
    }

    // Swiper

    var initIterator = 0;
    var $breakPoints = false;
    jQuery('.swiper-container').each(function () {

        var $t = jQuery(this);
        var index = 'swiper-unique-id-' + initIterator;

        $t.addClass('swiper-' + index + ' initialized').attr('id', index);
        $t.find('.swiper-pagination').addClass('pagination-' + index);

        var $effect = ($t.data('effect')) ? $t.data('effect') : 'slide',
            $crossfade = ($t.data('crossfade')) ? $t.data('crossfade') : true,
            $loop = ($t.data('loop') == false) ? $t.data('loop') : true,
            $showItems = ($t.data('show-items')) ? $t.data('show-items') : 1,
            $scrollItems = ($t.data('scroll-items')) ? $t.data('scroll-items') : 1,
            $scrollDirection = ($t.data('direction')) ? $t.data('direction') : 'horizontal',
            $mouseScroll = ($t.data('mouse-scroll')) ? $t.data('mouse-scroll') : false,
            $autoplay = ($t.data('autoplay')) ? parseInt($t.data('autoplay'), 10) : 0,
            $slidesSpace = ($showItems > 1) ? 20 : 0;

        if ($showItems > 1) {
            $breakPoints = {
                480: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                }
            }
        }

        swipers['swiper-' + index] = new Swiper('.swiper-' + index, {
            pagination: '.pagination-' + index,
            paginationClickable: true,
            direction: $scrollDirection,
            mousewheelControl: $mouseScroll,
            mousewheelReleaseOnEdges: $mouseScroll,
            slidesPerView: $showItems,
            slidesPerGroup: $scrollItems,
            spaceBetween: $slidesSpace,
            keyboardControl: true,
            setWrapperSize: true,
            preloadImages: true,
            updateOnImagesReady: true,
            autoplay: $autoplay,
            loop: $loop,
            breakpoints: $breakPoints,
            effect: $effect,
            fade: {
                crossFade: $crossfade
            },
            parallax: true,
            onImagesReady: function (swiper) {
                // CRUMINA.resizeSwiper(swiper);
            },
            onSlideChangeStart: function (swiper) {
                if ($t.find('.slider-slides').length) {
                    $t.find('.slider-slides .slide-active').removeClass('slide-active');
                    var realIndex = swiper.slides.eq(swiper.activeIndex).attr('data-swiper-slide-index');
                    $t.find('.slider-slides .slides-item').eq(realIndex).addClass('slide-active');
                }
                CRUMINA.resizeSwiper(swiper);
            }
        });
        initIterator++;
    });

    //swiper arrows
    jQuery('.btn-prev').on('click', function () {
        swipers['swiper-' + jQuery(this).parent().attr('id')].slidePrev();
    });

    jQuery('.btn-next').on('click', function () {
        swipers['swiper-' + jQuery(this).parent().attr('id')].slideNext();
    });

    //swiper tabs
    jQuery('.slider-slides .slides-item').on('click', function () {
        if (jQuery(this).hasClass('slide-active')) return false;
        var activeIndex = jQuery(this).parent().find('.slides-item').index(this);
        swipers['swiper-' + jQuery(this).closest('.swiper-container').attr('id')].slideTo(activeIndex + 1);
        jQuery(this).parent().find('.slide-active').removeClass('slide-active');
        jQuery(this).addClass('slide-active');

        return false;

    });

    // Newsletter

    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({triggerElement: ".subscribe"})
        .setVelocity(".gear", {opacity: 1, rotateZ: "360deg"}, 1200)
        .triggerHook("onEnter")
        .addTo(controller);

    new ScrollMagic.Scene({triggerElement: ".subscribe"})
        .setVelocity(".mail", {opacity: 1, bottom: "0"}, 600)
        .triggerHook(0.8)
        .addTo(controller);

    new ScrollMagic.Scene({triggerElement: ".subscribe"})
        .setVelocity(".mail-2", {opacity: 1, right: "20"}, 800)
        .triggerHook(0.9)
        .addTo(controller);
});